import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent} from 'react';

export const TokenSelectionButton: FunctionComponent<
  {
    selected: boolean;
    onClick: () => void;
  } & DefaultChildren
> = ({selected, onClick, children}) => {
  return (
    <button
      type='button'
      className={`${
        selected
          ? 'bg-blue-600 text-white border-blue-600 pointer-events-none'
          : 'bg-transparent border-gray-400 text-gray-400'
      } w-full p-1 border text-sm rounded-lg min-w-[60px] hover:opacity-70 transition-all duration-200 ease-in-out`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
